var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "function_list"
  }, [_c("div", {
    staticClass: "functions"
  }, [_c("div", {
    staticClass: "functions_flex"
  }, _vm._l(_vm.itemList, function (item, index) {
    return _c("div", {
      key: item.title,
      staticClass: "functions_flex_item",
      style: {
        marginRight: `${(index + 1) % _vm.rowCol === 0 ? "0px" : "4px"}`
      }
    }, [_c("div", {
      class: ["ads-title", {
        "active-title": _vm.activeKey === index
      }],
      style: {
        width: `${_vm.rowCol === 4 ? "317px" : "424px"}`
      },
      on: {
        click: function ($event) {
          _vm.activeKey = index;
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "item.key"
      }
    }), _c("div", {
      staticClass: "desc"
    }, [_c("span", [_vm._v(_vm._s(item.title))])])]), _vm.activeKey === index ? _c("div", {
      staticClass: "text-placeholder"
    }) : _vm._e(), _vm.activeKey === index ? _c("div", {
      staticClass: "text",
      style: _vm.textStyle
    }, [_c("div", {
      staticClass: "explain"
    }, [_c("p", [_vm._v(_vm._s(item.desc))])])]) : _vm._e()]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };